import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { AuthService, SessionData, AuthGroupManager, HeaderData, ConfigManager, Config } from '../../services/Auth';
import { Store } from 'vuex';
import { PortalAppMode, PortalAppStatus } from '../../services/Auth/types';
import { AxiosResponse } from 'axios';
import { ResponseEnvelope } from '../../services';
import PortalAppService from '../../services/Auth/PortalAppService';

@Module({
	namespaced: true
})
export default class AuthStore extends VuexModule {
	headerData?: HeaderData;
	configManager?: ConfigManager;
	sessionData?: SessionData;
	authManager?: AuthGroupManager;
	userStatus = 'unloaded';
	portalAppStatus: PortalAppMode = PortalAppMode.NOT_IMPLEMENTED;

	@Mutation
	setHeaderData(data: HeaderData): void {
		this.headerData = data;
	}

	@Mutation
	setConfigManager(data: Config): void {
		this.configManager = new ConfigManager(data);
	}

	@Mutation
	setUserStatus(status: string): void {
		this.userStatus = status;
	}

	@Mutation
	setSessionData(data: SessionData): void {
		this.sessionData = data;
	}

	@Mutation
	setAuthManager(data: AuthGroupManager): void {
		this.authManager = data;
	}

	@Mutation
	setPortalAppStatus(data: PortalAppStatus): void {
		this.portalAppStatus = data.status;
	}

	@Action
	initializePortalSession(store: Store<Record<string, unknown>>): Promise<unknown | void> {
		const authSvc = new AuthService(store);
		return authSvc.getPortalHeader()
			.then(resp => {
				this.context.commit('setHeaderData', resp.data);
				this.context.commit('setConfigManager', resp.data.config);
				return authSvc.getSession();
			})
			.then(resp => {
				this.context.commit('setAuthManager', new AuthGroupManager(resp.data));
				this.context.commit('setSessionData', resp.data);
				this.context.commit('setUserStatus', 'loaded');
				return Promise.resolve();
			})
			.catch(() => ({}));
	}

	@Action
	refreshMaintenanceMode(store: Store<Record<string, unknown>>): Promise<void> {
		const portalAppSvc = new PortalAppService(store);
		return portalAppSvc.getPortalAppStatus()
			.then((resp: AxiosResponse<ResponseEnvelope<PortalAppStatus>>) => {
				this.context.commit('setPortalAppStatus', resp.data.data);
				return Promise.resolve();
			});
	}
}